import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { positionsActions, devicesActions, sessionActions, eventDataActions } from './store';
import { useHistory } from 'react-router-dom';
import { useEffectAsync } from './reactHelper';

const SKIP_HASH_LIST = ['termcondition'];

const displayNotifications = events => {

  if ("Notification" in window) {
    if (Notification.permission === "granted") {
      for (const event of events) {
        const notification = new Notification(`Event: ${event.type}`);
        setTimeout(notification.close.bind(notification), 4 * 1000);
      }
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission(permission => {
        if (permission === "granted") {
          displayNotifications(events);
        }
      });
    }
  }
};

const SocketController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const authenticated = useSelector((state) => !!state.session.user);
  let timerId = null;
  let initialTimeoutTime = 100;
  let copyDevicesData = [];
  let copyPositionsData = [];
  let copyEventsData = [];

  const connectSocket = () => {
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const socket = new WebSocket(
      protocol + "//" + window.location.host + "/api/socketEvents"
    );

    socket.onclose = () => {
      setTimeout(() => connectSocket(), 60 * 1000);
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      // if (data.devices) {
      //   // dispatch(devicesActions.update(data.devices));
      //   copyDevicesData = copyDevicesData.concat(data.devices);
      // }
      // if (data.positions) {
      //   copyPositionsData = copyPositionsData.concat(data.positions);
      //   // dispatch(positionsActions.update(data.positions));
      // }
      if (data.events) {
        // console.log("Notification ",data.events);
        // displayNotifications(data.events);
        dispatch(eventDataActions.addState(data.events));
        // copyEventsData = copyEventsData.concat(data.events);
      }
      if (timerId) {
        initialTimeoutTime = 15000;
        return;
      }
      timerId = setTimeout(function () {
        // const data = JSON.parse(event.data);
        // if (copyDevicesData && copyDevicesData.length > 0) {
        //   dispatch(devicesActions.update(copyDevicesData));
        // }
        // if (copyPositionsData && copyPositionsData.length > 0) {
        //   dispatch(positionsActions.update(copyPositionsData));
        // }
        // if (copyEventsData && copyEventsData.length>0) {
        //   displayNotifications(copyEventsData);
        // }

        copyDevicesData = [];
        copyPositionsData = [];
        copyEventsData = [];
        timerId = undefined;
      }, initialTimeoutTime);
    };
  };

  useEffectAsync(async () => {
    const response = await fetch("/api/server");
    if (response.ok) {
      dispatch(sessionActions.updateServer(await response.json()));
    }
  }, []);

  useEffectAsync(async () => {
    if (authenticated) {
      const response = await fetch("/api/devices");
      if (response.ok) {
        dispatch(devicesActions.refresh(await response.json()));
      }
      connectSocket();
    } else {
      const response = await fetch("/api/session");
      if (response.ok) {
        dispatch(sessionActions.updateUser(await response.json()));
      } else {
        const URL = window.location && window.location.pathname;
        let skip = false;
        SKIP_HASH_LIST.forEach((element) => {
          skip = skip || URL.includes(element);
        });
        !skip && history.push("/login");
      }
    }
  }, [authenticated]);

  return null;
};

export default connect()(SocketController);
